/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Icsrm_Einblick_Arbeitsalltag26Inputs */

const en__field_enum_icsrm_einblick_arbeitsalltag26 = /** @type {(inputs: _Field_Enum_Icsrm_Einblick_Arbeitsalltag26Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get to know every day working life`)
};

const de__field_enum_icsrm_einblick_arbeitsalltag26 = /** @type {(inputs: _Field_Enum_Icsrm_Einblick_Arbeitsalltag26Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einblick in Arbeitsalltag erhalten`)
};

/**
* | output |
* | --- |
* | "Get to know every day working life" |
*
* @param {_Field_Enum_Icsrm_Einblick_Arbeitsalltag26Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_icsrm_einblick_arbeitsalltag26 = /** @type {((inputs?: _Field_Enum_Icsrm_Einblick_Arbeitsalltag26Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Icsrm_Einblick_Arbeitsalltag26Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_icsrm_einblick_arbeitsalltag26(inputs)
	return de__field_enum_icsrm_einblick_arbeitsalltag26(inputs)
});
export { _field_enum_icsrm_einblick_arbeitsalltag26 as "_field_enum_ICSRM_EINBLICK_ARBEITSALLTAG" }